import {
  faArrowLeft,
  faCheck,
  faUnlockKeyhole,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMutation } from "@tanstack/react-query";
import { changePassword, forgotPassword } from "api/services/auth";
import Alert from "components/Alert";
import Button from "components/Button";
import InputField from "components/FormFields/InputField";

import AuthLayout from "layouts/AuthLayout";
import React, { useState } from "react";
import { twMerge } from "tailwind-merge";

export default function ChangePassword() {
  const [passwordChanged, setPasswordChanged] = useState(false);
  const changePassMutation = useMutation({
    mutationFn: changePassword,
    onSuccess: ({ data }) => {
      if (data?.user?.id) {
        setPasswordChanged(true);
      }
    },
    onMutate: () => {
      setPasswordChanged(false);
    },
  });

  const isValidationError =
    changePassMutation.isError &&
    changePassMutation.error?.response?.data?.error?.name == "ValidationError";

  return (
    <AuthLayout>
      <div className="p-2 rounded-tr-4xl z-10">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const newPassword = e.target.newPassword.value;
            const repeatPassword = e.target.repeatPassword.value;

            // if (newPassword !== repeatPassword) {
            //   return;
            // }

            changePassMutation.mutate({
              currentPassword: e.target.currentPassword.value,
              passwordConfirmation: newPassword,
              password: repeatPassword,
            });
          }}
        >
          <InputField
            id="currentPassword"
            name="currentPassword"
            label="Cari şifrə"
            placeholder="Cari şifrəni daxil edin"
            required
            type="password"
            onInvalid={(e) => {
              e.target.setCustomValidity("");
              if (!e.target.validity.valid) {
                e.target.setCustomValidity(
                  "Zəhmət olmasa, cari şifrəni daxil edin"
                );
              }
            }}
          />
          <InputField
            id="newPassword"
            name="Yeni şifrə"
            label="Yeni şifrə"
            placeholder="Yeni şifrəni daxil edin"
            minLength="6"
            type="password"
            onInput={(e) => {
              e.target.setCustomValidity("");
              if (!e.target.validity.valid) {
                e.target.setCustomValidity(
                  "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
                );
              }
            }}
            onInvalid={(e) => {
              e.target.setCustomValidity("");
              if (!e.target.validity.valid) {
                e.target.setCustomValidity(
                  "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
                );
              }
            }}
            required
          />

          <InputField
            id="repeatPassword"
            required
            name="Şifrə təkrarı"
            label="Şifrə təkrarı"
            minLength="6"
            type="password"
            placeholder="Yeni şifrəni təkrar daxil edin"
            onInput={(e) => {
              e.target.setCustomValidity("");
              if (!e.target.validity.valid) {
                e.target.setCustomValidity(
                  "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
                );
              }
            }}
            onInvalid={(e) => {
              e.target.setCustomValidity("");
              if (!e.target.validity.valid) {
                e.target.setCustomValidity(
                  "Şifrə ən azı 6 simvoldan ibarət olmalıdır"
                );
              }
            }}
          />
          <Button
            isLoading={changePassMutation.isLoading}
            className="mb-4 w-full fill-white"
          >
            Şifrəni dəyiş
          </Button>
          {isValidationError && (
            <Alert type="error">
              {changePassMutation.error?.response?.data?.error?.message}
            </Alert>
          )}

          {passwordChanged && (
            <Alert type="success">
              Şifrəniz uğurla dəyişdirildi. Yeni şifrənizlə sistemə daxil ola
              bilərsiniz.
            </Alert>
          )}
        </form>
      </div>
    </AuthLayout>
  );
}
